import { Divider, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { ProductItem, ProductTotal } from '../../components';
import { useCrossSellerState } from '../../store';

export const PaymentMyProducts = () => {
  const { t } = useTranslation('cross-seller/common');

  const { selectedPlans } = useCrossSellerState();

  const total = selectedPlans.reduce(
    (acc, plan) => acc + plan.amountPrice * plan.quantity,
    0,
  );

  return (
    <Flex
      flexDir="column"
      bg="brand.50"
      px={10}
      py={14}
      borderRadius={16}
      minW={420}
      gap={5}
      minH="full"
    >
      <Text color="brand.500" fontSize="2xl" fontWeight="semibold">
        {t('myProducts')}
      </Text>

      <Flex flexDir="column" bg="white" gap={5} p={5} borderRadius={12}>
        {selectedPlans.map((plan, index) => (
          <ProductItem key={plan.planId + index} product={plan} />
        ))}

        <Flex
          justifyContent="space-between"
          alignItems="center"
          color="brand.500"
        >
          <Text fontWeight="semibold" fontSize="sm">
            {t('shipping')}
          </Text>

          <Text fontWeight="semibold" fontSize="lg" textTransform="uppercase">
            {t('free')}
          </Text>
        </Flex>

        {selectedPlans.length > 0 && <Divider borderWidth={0.5} />}

        <ProductTotal total={total} />
      </Flex>
    </Flex>
  );
};
